import React, { useContext } from 'react';
import EmptyBackground from '../EmptyBackground';
import { getFeature } from '../../../DaEditorWrapper/Features';
import { FIRST_IMAGE_FEATURE } from '../../../DaEditorWrapper/Features/firstImage';
import BackgroundImage from '../../BackgroundImage';
import { useFlag } from '../../../redux/flags/hooks';
import MediaService from '../../../utils/DeviationMediaService';
import { MatureContext } from '../../../Context';
import s from './Commission.scss';
function getCoverImageFile(deviation, showMatureContent, upliftEnabled) {
    var textContent = deviation.textContent, commission = deviation.commission;
    var coverImage = undefined;
    if (upliftEnabled) {
        coverImage = deviation.coverImage;
    }
    if (!coverImage) {
        if (textContent && textContent.html.type === 'draft') {
            var first = getFeature(FIRST_IMAGE_FEATURE, textContent.html.features);
            if (first) {
                coverImage = first.data.deviation;
            }
        }
        else if (commission) {
            if (commission.examples && commission.examples.length) {
                coverImage = commission.examples[0];
            }
        }
    }
    if (coverImage && coverImage.isMature && !showMatureContent) {
        return null;
    }
    return coverImage && MediaService.getLargestFullview(coverImage);
}
export var CommissionStageBackground = function (_a) {
    var deviation = _a.deviation, _b = _a.height, height = _b === void 0 ? 0 : _b, _c = _a.width, width = _c === void 0 ? 0 : _c;
    var showMatureContent = useContext(MatureContext);
    var upliftEnabled = useFlag('commissions_uplift');
    var coverImage = getCoverImageFile(deviation, showMatureContent, upliftEnabled);
    if (!coverImage) {
        return React.createElement(EmptyBackground, { className: s['empty-background'] });
    }
    var _d = coverImage.width, coverWidth = _d === void 0 ? 0 : _d, _e = coverImage.height, coverHeight = _e === void 0 ? 0 : _e, src = coverImage.src;
    var shouldBlur = coverHeight < height || coverWidth < width;
    return React.createElement(BackgroundImage, { src: src, blur: shouldBlur });
};
CommissionStageBackground.displayName = 'CommissionStageBackground';
export default CommissionStageBackground;
//# sourceMappingURL=Commission.js.map